if (!customElements.get('s-main-collection')) {
  customElements.define('s-main-collection', class SectionMainCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.cacheElements()
        this.addEventListener("change", this.changeHandler)
        this.addEventListener("click", this.clickHandler)
        window.addEventListener("scroll", this.stickyHandler, { passive: true })
        window.addEventListener("resize", this.stickyHandler)
        this.stickyHandler()

        subscribe("filter-changer", this.inputChanger)
        subscribe("sort-changer", this.sortHandler)
      }

      disconnectedCallback() {
        this.removeEventListener("change", this.changeHandler)
        this.removeEventListener("click", this.clickHandler)
        window.removeEventListener("scroll", this.stickyHandler)
        window.removeEventListener("resize", this.stickyHandler)
      }

      filterOpener = () => {
        publish("open-filter-modal")
      }

      cacheElements = () => {
        this.productList = this.querySelector(".js-main-collection__list");
        this.sort = this.querySelector(".js-main-collection__sort-wrapper");
        this.paginations = Array.from(this.querySelectorAll(".js-main-collection__pagination"));
        this.mobileContainer = this.querySelector(".js-main-collection__mobile-wrapper");
      }

      closeFilterDetails = (exceptFilter = null) => {
        this.querySelectorAll(".s-main-collection__filter[open]").forEach(filter => {
          if (filter === exceptFilter) return;

          filter.removeAttribute("open")
        })
      }

      stickyHandler = () => {
        let headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 72;

        if (this.sort) {
          let sortTop = this.sort.getBoundingClientRect().top;
          this.sort.classList.toggle("is-sticky", sortTop <= headerHeight + 1);
        }

        if (this.mobileContainer) {
          let mobileTop = this.mobileContainer.getBoundingClientRect().top;
          this.mobileContainer.classList.toggle("is-sticky", mobileTop <= headerHeight + 1);
        }
      }

      sortHandler = event => {
        let value = event.target.value;

        const url = new URL(window.location.href);
        const params = url.searchParams;
    
        if (params.has('sort_by')) {
            params.set('sort_by', value);
        } else {
            params.append('sort_by', value);
        }
    
        this.filterChangeHandler(`${url.pathname}?${params.toString()}`)
      }

      changeHandler = (event) => {
        if (event.target.closest(".js-main-collection__sort-select")) {
          this.sortHandler(event);
          return;
        }

        if (event.target.matches(".js-main-collection__filter-value input")) {
          this.inputChanger(event);
        }
      }

      clickHandler = (event) => {
        if (event.target.closest(".js-main-collection__modal-button")) {
          this.filterOpener()
        }

        let filterSummary = event.target.closest(".s-main-collection__filter summary");
        if (filterSummary) {
          let currentFilter = filterSummary.closest(".s-main-collection__filter");

          if (currentFilter && !currentFilter.open) {
            this.closeFilterDetails(currentFilter);
          }
        }
      }

      inputChanger = (event) => {
        let input = event.target
        let updatedUrl = input.checked ? input.dataset.filterAdd : input.dataset.filterRemove;

        if (!updatedUrl) return;

        this.classList.add("is-loading")
        this.filterChangeHandler(updatedUrl)
      }

      filterChangeHandler = (updatedUrl) => {
        fetch(updatedUrl)
        .then(res => res.text())
        .then(response => {
          let newDom = new DOMParser().parseFromString(response, "text/html");
          let newSection = newDom.querySelector("s-main-collection");
          if (!newSection) return;

          this.innerHTML = newSection.innerHTML;
          this.cacheElements()
          this.stickyHandler()

          publish("update-filter", newDom)

          window.history.pushState(null, '', updatedUrl);
        })
        .finally(() => {
          this.classList.remove("is-loading")
        })
        .catch(error => {
          console.log(error)
        })
      }
    }
  );
}
